//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
import {  Check , Close } from '@mui/icons-material';
import { find, get , has, isEmpty, isPlainObject } from "lodash";
import moment from "moment";
import { lighten, invert } from "polished";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
//  -- Thunks -------------------------
import { handleCreatePastSubmission } from "store/pastSubmission/thunks";
import styled from "styled-components";
//  -- Constants ----------------------
import COLOR from "utils/constants/color";
import { getExceptionStatus, imageFetch, imageFetchFromPodcast, isVideo, shouldSkipLateDateForDiffStudent } from "utils/lib/ebookHelper";
import { TootipWrapper } from "components/TooltipWrapper";
import RetakeModal from "components/RetakeModal";
import GraphicAssignmentTake from "./GraphicAssignmentTake";
import { useLocation } from "react-router-dom";
import queryString from 'query-string';
import { Tooltip } from "antd";
import { isDisabledForMe } from "utils/methods/validateData";
import { Drawer} from "antd"
import StudentSubmissionView from "features/forms/StudentSubmissionView";
import Loading from "./Loading";
import { handleListUserSubmissionsByClass } from "store/submissions/thunks";
import { useCurrentClass } from "store/classes/selectors";
import { checkIsManualGradable, isBeforTime } from "utils/methods/math";
import SpinLoader from "./Loader/SpinLoader";
import * as Sentry from '@sentry/react';
import { NoteMark } from "./UI";
import { useAlert } from './UI/alertSakeBar/alertProvider';
import { useAllBook } from 'store/books/selectors';
import { useResources } from 'store/resources/selectors';
import { isWaitingForAiGradingRestriction } from 'utils/methods/functions';
import CountdownTimer from './CountdownTimer';
import { useUserProfileConfig } from 'store/users/selectors';
import { useAudioPermissionCheck } from './hooks/useAudioPermission/useAudioPermissionCheck';
import { useStudentHaveDiff } from './hooks/students/useStudentHaveDiff';
import { updateUI } from 'store/UI/actions';
import { usePageCover } from './hooks/pageCover/pageCover';
import MicrophonePermissionModal from './UI/modal/MicrophonePermissionModal';
import completeModeSvg from "../utils/assets/images/completeMode.svg";
import completedSvg from "../utils/assets/images/completed.svg";
import lastSubSvg from "../utils/assets/images/last-sub.svg";
import clockSvg from "../utils/assets/images/Clock.svg";
import dueDateSvg from "../utils/assets/images/dueDate.svg";
import SentryWrap from 'components/Sentry';
import { useGradeBook } from './hooks/gradeBook/useGradeBook';
import useCheckAudioAndWritten from './UI/scoreMessage/useCheckAudioAndWritten';
import ScoreMessage from './UI/scoreMessage';
import useIsExamActive from './hooks/books/useIsExamActive';
import { useUI } from 'store/UI/selectors';
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
import { firebaseApp } from 'firebaseConfig';
import { assignmentStatusDocumentId } from 'utils/methods/assignmentStatusFirestore';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const ASSIGNMENT_BG = ['#cfd5d045', '#dbe4f0', '#58aedb4f', '#dda4e74d', '#3fdd6645', '#e9bf864d'];

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  align-items: ${(p) => p.align || "center"};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;
  width: 100%;

  &:last-child {
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 0px;
  }
`;

const Text = styled.span`
  color: ${COLOR.black500};
  font-size: 11px;
  margin-top: 2px;
  text-align: left;
  display:flex;
`;

const TextLarge = styled(Text)`
  color: ${(p) =>
    p.disabled
      ? `${COLOR.redishpink}`
      : p.complete
      ? COLOR.green100
      : "#3D5F8F"};
  font-size: 14px;
  font-weight: 600;
  margin-right: 4px;
`;

const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  color: #302D2C;
`;

const Wrapper = styled.button`
  // background-color: ${(p) => (p.bgColor ? p.bgColor : COLOR.white)};
  // border: 2px dashed ${(p) =>  p.disabled ? `${COLOR.redishpink}` : p.complete ? lighten(0.3, COLOR.green100) : p.bgColor ? lighten(0.2, invert(p.bgColor)) : lighten(0.3, "#3D5F8F")};
  // border-radius: 4px;
  // color: ${(p) => p.disabled ? `${COLOR.redishpink}` : p.complete ? COLOR.green100 : "#3D5F8F"};
  // cursor: pointer;
  // font-size: 14px;
  // font-weight: 400;
  // margin-top: 16px;
  // outline: none;
  // padding: 12px 12px 10px;
  // transition: all 300ms ease;
  // width: 100%;

  // &:last-child {
  //   margin-bottom: 16px;
  // }

  // &:hover {
  //   background-color: ${(p) => p.complete ? lighten(0.55, COLOR.green100) : lighten(0.55, "#3D5F8F")};
  // }


    border: 2px solid ${(p) =>
      p.disabled
        ? `${COLOR.redishpink}`
        : p.complete
        ? "#64DD16"
        : p.isUnitExam ? '#ffa947': p.isExam ? '#0f2c70' 
        : p.isGeneratedTest
        ? "#2C3A47"
        : p.bgColor ? p.bgColor : '#88ADE2'};
    border-radius: 11px;
    color: ${(p) =>
      p.disabled
        ? `${COLOR.redishpink}`
        : p.complete
        ? COLOR.green100
        : "#3D5F8F"};
    // cursor: ${(p) => (p.disabled ? "no-drop" : "pointer")};
    font-size: 14px;
    font-weight: 400;
    margin-top: 16px;
    outline: none;
    padding: 12px 12px 10px;
    transition: all 300ms ease;
    width: 100%;
    background-color: ${(p) => (p.bgColor && !ASSIGNMENT_BG.includes(p.bgColor) ? p.bgColor : COLOR.white)};
    position: relative;
    padding-left: 30px !important;

    &::before {
        width: 20px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background: ${(p) =>
          p.disabled
            ? `${COLOR.redishpink}`
            : p.complete
            ? "#64DD16"
            : p.bgColor
            ? p.isUnitExam
              ? "#CCE4E4"
              : p.isExam
                ? "#0F2C70"
                : p.isGeneratedTest
                  ? "#cffafe"
                  : "#88ADE2"
            : p.isUnitExam
              ? "#CCE4E4"
              : p.isExam
                ? "#0F2C70"
                : p.isGeneratedTest
                  ? "#cffafe"
                  : "#88ADE2"};
        content: "";
        border-radius: 8px 0px 0px 8px;
    }

    // &:hover {border: 2px solid ${(p) => p.complete ? "#5ed014" : lighten(0.40, "#3D5F8F")};}
    // &:hover&::before {background-color: ${(p) => p.complete ? "#5ed014" : lighten(0.55, "#3D5F8F")};}


`;
const BookDescRow = styled(Row)`
  font-size: 10px;
  padding-left: 30px;
  margin-top: -15px;
`;

const GradeBadge = ({ grade }) => {
  if (!grade) return null;

  const gradeConfig = {
      Missing: { color: '#e74c3c', label: 'Missing' },
      Incomplete: { color: '#e67e22', label: 'Incomplete' },
      Excused: { color: '#27ae60', label: 'Excused' },
  };

  const config = gradeConfig[grade] || { color: '#333', label: grade };

  return (
      <span style={{ color: config.color }}>
          {config.label}
      </span>
  );
};

const AssignmentNotification = ({
  assignment,
  onClick,
  submissions,
  userRol,
  currentUser,
  is_extension_activity = false,
  is_engage_activity = false,
  engagetData = []
}) => {
  const bookAllList = useAllBook();
  const resources = useResources();
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const activeSubmission = useMemo(()=>{
    const sub = find(submissions, [
      "assignmentId",
      assignment?.data?.id,
    ])
    if(sub&&!sub.assignment){
      sub.assignment = assignment?.data
    }
    return sub;
  },[submissions,assignment]);
  const { isException, exceptionStatusText } =
    getExceptionStatus(activeSubmission,currentUser);
  const [isRetakeOpen, setisRetakeOpen] = useState(false);
  const bookDescription = get(assignment, "data.bookDescription");
  const colorCode = get(assignment, "data.colorCode");
  const retakeAvailable = activeSubmission
    ? activeSubmission?.exceptionStatus ==3?true: parseInt(activeSubmission?.submissions, 10) <
      parseInt(assignment?.retakes, 10) + 1
    : true;
  const deactive_for_me =  useMemo(()=>isDisabledForMe(assignment,currentUser.id),[assignment,currentUser])
  const isActive = get(assignment, "active", true) && !deactive_for_me;
  const [firestoreClassActive, setFirestoreClassActive] = useState(null);
  const [reviewDrawer,setEeviewDrawer] = useState(false)
  const [loading , setLoading] = useState(false)
  const ungraded = get(assignment, "ungraded", false)
  const grade_type = get(assignment,"grade_type");
  const chapter = get(assignment, "data.chapter")
  const assignment_page =  get(assignment, "data.page")
  const isCompleteInComplete = grade_type === "complete_incomplete"
  const max_point = assignment?.max_point && !isNaN(assignment?.max_point) ? Number.parseInt(assignment.max_point, 10) : 100
  const isPointSystem =  grade_type === "points"
  const [openAssignmentModal,setOpenAssignmentModal] = useState(false)
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const currentClass = useCurrentClass();
  const effectiveActive = useMemo(() => {
    if (userRol !== 'student' || is_extension_activity) return isActive;
    if (firestoreClassActive === false) return false;
    if (firestoreClassActive === true) return !deactive_for_me;
    return isActive;
  }, [userRol, is_extension_activity, firestoreClassActive, isActive, deactive_for_me]);

  useEffect(() => {
    if (is_extension_activity || userRol !== 'student' || !currentClass?.id || !assignment?.data?.id) {
      setFirestoreClassActive(null);
      return undefined;
    }
    const kind =
      assignment.data.typeId === 'quiz' || assignment.data.typeId === 'quizresource'
        ? 'quiz'
        : 'activity';
    const db = getFirestore(firebaseApp);
    const statusRef = doc(
      db,
      'assignment_status',
      assignmentStatusDocumentId(currentClass.id, kind, assignment.data.id),
    );
    const unsub = onSnapshot(
      statusRef,
      (snap) => {
        if (!snap.exists()) {
          setFirestoreClassActive(null);
          return;
        }
        const raw = snap.data()?.active;
        if (raw === true) setFirestoreClassActive(true);
        else if (raw === false) setFirestoreClassActive(false);
        else setFirestoreClassActive(null);
      },
      () => {},
    );
    return () => unsub();
  }, [
    userRol,
    is_extension_activity,
    assignment?.data?.id,
    assignment?.data?.typeId,
    currentClass?.id,
  ]);

  const view_result = useMemo(() => {
    const result_visibility_on = assignment?.result_visibility_on;
    return result_visibility_on ? isBeforTime(result_visibility_on) : true
  }, [])
  
  const {  checkAudioQuestionsAndRequestPermission } = useAudioPermissionCheck();
  const { isAudioAndWritten, isCheckAudiOrWritten } = useCheckAudioAndWritten({ questions: assignment?.data?.questions });
  const {checkAllTypeExamBook} = useIsExamActive();
  const {openScoreMessageModal} = useUI();
  const pageCover = usePageCover({ assignmentData: assignment?.data });
  const modalSrc = useMemo(() => pageCover? pageCover: isVideo(chapter, resources) ? imageFetchFromPodcast(chapter, resources) : imageFetch(bookAllList, chapter, assignment_page), [pageCover,resources, bookAllList]);
  const {hasValidAiFeedback} = useGradeBook();
  
  useEffect(() => {
    const search = queryString.parse(location.search);
    if (search.assignment_type === "graphic_organizer" && (search?.id === assignment.id||search.activity_id === assignment.id ||search.activity_id === assignment.data.id)) {
      setOpenAssignmentModal(true)
    }
  }, [location])

  const showCountdownTimer = useMemo(() => {
    if (assignment?.data?.id && currentUser?.role === 'student') {
      if (activeSubmission?.finish_later!==null && activeSubmission?.complete===false) {
        return true;
      } else {
        return false;
      }
    }
  }, [assignment?.data?.id, currentUser?.role, activeSubmission]);

  const stopAllAudio = () => {
    const mediaElements = document.querySelectorAll('audio, video');
    
    mediaElements.forEach((element) => {
      try {
        if (!element || !(element instanceof HTMLMediaElement)) {
          return;
        }
        if (typeof element.pause === 'function') {
          element.pause();
        }
        if (typeof element.currentTime !== 'undefined') {
          element.currentTime = 0;
        }
      } catch (error) {
        console.warn('Error stopping media element:', error);
      }
    });
  };


  const is_graphic_organizer = get(assignment, "data.activity_type") === "graphic_organizer"
  const handleClick = async (e) => {
    if (assignment?.data) {
      const hasAudioPermission = await checkAudioQuestionsAndRequestPermission(assignment.data);
      if (!hasAudioPermission) {
        return;
      }
    } 
    if(assignment?.data && (activeSubmission === undefined || activeSubmission === null || !activeSubmission.id) && checkAllTypeExamBook(assignment?.data?.chapter) && isAudioAndWritten){
      dispatch(updateUI({ openScoreMessageModal: {open: true, category: assignment?.ai_grading_config?.grade_level, isCheckAudiOrWritten: isCheckAudiOrWritten(assignment?.data?.questions)} }));
    }
    stopAllAudio();
    if (is_engage_activity) {
      dispatch(updateUI({openEngageModalTeacher: {open: true, data: engagetData}}));
    }
    if (userRol === 'student') {
      if (!effectiveActive) return;
    } else if (!isActive) {
      return;
    }
    const assignmentId = assignment?.data?.id ?? assignment?.id;
    const shouldOpenStoryWidget = userRol === "student" && ((!activeSubmission) || (activeSubmission?.complete && retakeAvailable));
    if (activeSubmission?.complete && !retakeAvailable) {
      return;
    } else if (activeSubmission?.complete && retakeAvailable) {
      try {
        if (shouldOpenStoryWidget && assignmentId) {
          localStorage.setItem(`open_story_ai_${assignmentId}`, "true");
          localStorage.removeItem(`skip_story_ai_${assignmentId}`);
        }
        setLoading(true)
        await dispatch(
          handleCreatePastSubmission({ submissionId: activeSubmission?.id , is_missing: activeSubmission?.exceptionStatus ==3?true: false, is_retake:activeSubmission?.complete && retakeAvailable ? true: false  })
        );
        if (assignment?.data?.id) {
          localStorage.removeItem(`finishLater_${assignment.data.id}`);
        }
      } catch (error) {
        console.log(error);
        showAlert("Something went wrong!", "error");
        Sentry.captureException(`148 Error in creating past submission: ${error}`);
      } finally {
        setLoading(false)
      }
      if (is_graphic_organizer) {
        setOpenAssignmentModal(true)
      } else {
        onClick();
      }
    } else {
      if (shouldOpenStoryWidget && assignmentId) {
        localStorage.setItem(`open_story_ai_${assignmentId}`, "true");
        localStorage.removeItem(`skip_story_ai_${assignmentId}`);
      }
      if (is_graphic_organizer) {
        setOpenAssignmentModal(true)
      } else {
        onClick();
      }
    }
  };
  const isWaitingForAiGrading = () =>{
    const is_waiting = isWaitingForAiGradingRestriction(activeSubmission,assignment,isAiPermissionEnabled);
    if(is_waiting){
      showAlert("Please wait while the AI processes your grading.", "warning");
      return true
    }
    // if((Array.isArray(activeSubmission?.ai_grade) && activeSubmission?.ai_grade.length == 0)||( isPlainObject(activeSubmission?.ai_grade)&&isEmpty(activeSubmission?.ai_grade))){
    //   const is_waiting  =  activeSubmission.waiting_for_ai_grade
    //   if(is_waiting){
    //     showAlert("Please wait while the AI processes your grading.", "warning");
    //     return true
    //   }
    // }
    return false
  }
  const checkRetake = async (e) => {
    stopAllAudio()
    setEeviewDrawer(false);
    if (e) {
      e.preventDefault?.();
      e.stopPropagation?.();
    }
    if(isWaitingForAiGrading()){
      return;
    }
    if (isRetakeOpen) return;
    else if (activeSubmission?.complete && retakeAvailable) {
      window.dispatchEvent(new Event("closeStoryViewModal"));
        setisRetakeOpen(true);
    } else {
      if (!activeSubmission) {
        window.dispatchEvent(new Event("closeStoryViewModal"));
      }
        const assignmentId = assignment?.data?.id ?? assignment?.id;
        if (activeSubmission && assignmentId) {
          localStorage.setItem(`skip_story_ai_${assignmentId}`, "true");
        }
        handleClick();
    }
  };
  const getCompleteInclompleteMark = (isComplete)=>{
    if(isComplete){
      return <Check style={{ color: COLOR.green100, fontSize: 18 }} />
    } else{
      return <Close style={{ color: COLOR.red, fontSize: 18 }} />
    }
}
  const getGrade = () => {
    if (!activeSubmission) return '-';
    if(isException) return exceptionStatusText;
    const grade = activeSubmission?.grade >= 0 ? activeSubmission?.grade : '';
    const in_progress = activeSubmission && !activeSubmission.complete && activeSubmission.retaking
    let bg_text 
    if (currentUser?.role === 'student') {
      bg_text = 'TBG';
    } else {
      bg_text = activeSubmission&&activeSubmission.ai_grade&&activeSubmission.ai_grade.length > 0?"TBG - AI": "TBG";
    }
    // const bg_text = "TBG - AI";
    if (in_progress) return "-";
    if(!hasValidAiFeedback(activeSubmission)){
      return "Processing";
    }
    let isTbgObj = checkIsManualGradable(get(activeSubmission, "assignment.questions"));
    // show tbg if its true
    const isTbg = activeSubmission?.manualGrading && isTbgObj
    const face_grade = activeSubmission?.face_grade;
    if(activeSubmission?.assignmentType === "bingo" && ungraded){
      const isSubmitted = activeSubmission?.answers?.length > 0 ? activeSubmission?.answers?.some((el)=> el?.is_submitted):false;
      return isSubmitted ? 'Credit' : '-';
    }
    if (ungraded) return 'Credit'
    if (isCompleteInComplete && has(activeSubmission, "id")) {
      return getCompleteInclompleteMark(activeSubmission?.grade > 0);
    } else if (isPointSystem) {
      if (isTbg) {
        return  face_grade > 0 ||  face_grade == 0 ? `${face_grade}/${max_point} (${bg_text})`:`${bg_text}/${max_point}`;
      }
      return face_grade > 0 ||  face_grade == 0
        ? `${face_grade}/${max_point}`
        : `0/${max_point}`;
    } else {
      if (isTbg) {
        if (grade>0||grade==0) return `${grade} (${bg_text})`
        return bg_text;
      }
      return grade == 0 || grade > 0 ? grade : '-';
    }

  }
  const onReviewClick = (e) => {
    e.preventDefault();
    e.stopPropagation()
    setEeviewDrawer(true)
    
  }
  const oncloseDrawer = () => {
    setEeviewDrawer(false)
  }
  const getStatusText = () => {
    if (!effectiveActive && userRol === "student") return <button className='assignDeactivated'>Deactivated</button>;
    if (activeSubmission?.complete && retakeAvailable) return <button className='assignRetake'>Retake</button>;
    if (activeSubmission?.complete) return <button className='assignCompleted'>Completed</button>;
    if (isException) return exceptionStatusText;
    return activeSubmission ? <button className='assignResume'>Resume</button> :  <button className='assignTakeNow'>Take Now</button>;
  };

  const setRotateStatusText = () => {
    if (!effectiveActive && userRol === "student") return <label className='assignDeactivated'>DEACTIVATED</label>;
    if (activeSubmission?.complete && retakeAvailable) return <label className='assignRetake'>RETAKE</label>;
    if (activeSubmission?.complete) return <label className='assignCompleted'>COMPLETED</label>;
    if (isException) return exceptionStatusText;
    return activeSubmission ? <label className='assignResume'>RESUME</label> :  <label className='assignTakeNow'>TAKE NOW</label>;
  };

  const getUserSubmissions = async (e) => {
    if(loader){
      return;
    }
    try {
      e.preventDefault();
      e.stopPropagation()
      setLoader(true);
      await dispatch(
        handleListUserSubmissionsByClass(currentUser?.id, currentClass?.id)
      );
      setEeviewDrawer(true);
    } catch (error) {
      console.log(error);
      Sentry.captureException(`149 Error in getting user submissions: ${error}`);
    } finally {
      setLoader(false);
    }
  };
  const isGeneratedTest = useMemo(() => Boolean(assignment?.data?.generated_test), [assignment?.data?.generated_test])
  return (<SentryWrap>
   {openAssignmentModal? <GraphicAssignmentTake assignment={assignment} open={openAssignmentModal} setOpen={setOpenAssignmentModal} />:null}
        <SpinLoader dataloader={loading} />
    <Drawer
      height='100%'
      destroyOnHidden
      onClose={() => {
        oncloseDrawer()
      }}
      placement='top'
      open={reviewDrawer}
      key='assignmentNew'
      className='student-review-new'
    >
      <StudentSubmissionView
        data={assignment}
        submission={activeSubmission}
        chapter={assignment?.data?.chapter || assignment.chapter}
      />
    </Drawer>

    
    <Wrapper
      complete={activeSubmission?.complete}
      
      disabled={
        (!effectiveActive && userRol === "student")
      }
      bgColor={colorCode}
      isUnitExam={assignment?.data?.is_unit_exam}
      isExam={assignment?.data?.is_exam}
      isGeneratedTest={isGeneratedTest}
      className={isGeneratedTest ? 'addGeneratedTestCstm' : undefined}
    >
      <div onClick={checkRetake}>
      <MicrophonePermissionModal grantedAllow={handleClick} />

      <RetakeModal
        isRetakeOpen={isRetakeOpen}
        onClose={(e) => {
          setisRetakeOpen(false);
        }}
        onSubmit={handleClick}
      />
      <Row className='setFlexcenter'>
        {assignment?.data?.typeId === "activity" ? (
          // <Extension style={{ height: "18px", marginRight: "4px" }} />
          <>
          {activeSubmission?.complete ?  <img src={completeModeSvg} className='pastDueIcon'  width="" height={""} alt="" /> :  <img src={completedSvg} className='pastDueIcon'  width="" height={""} alt="" />}
          </>

        ) : (
          // <Assignment style={{ height: "18px", marginRight: "4px" }} />
          <img src={completedSvg} className='pastDueIcon'  width="" height={""} alt="" />
        )}
        <Tooltip placement="top" title={get(
            assignment,
            "displayName",
            get(assignment, "data.displayName", "")
          )}>
        <Title className="text-wrap">
          {get(
            assignment,
            "displayName",
            get(assignment, "data.displayName", "")
          )}
        </Title>
        </Tooltip>
        {is_extension_activity && (
          <span style={{ color: "#03989e" }}>
            (Extension Activity)
          </span>
        )}
       
      </Row>


      
       <div className='assignNotifyUpr assignNotifyUprStudentSide'>
       
        <div className='assignNotifyLft'>
        <Row className='studentCardInfo 111'>
        <Column className="cardStudentSide">
          {bookDescription ? (
            <div className="cardDetail">
              <div className='cardDetailInr'>
                <img src={lastSubSvg} alt="" title="" />
                <p>Book:</p>
              </div>  
              <span>{bookDescription}</span>
            </div> 
          ) : null}

          <div className="cardDetail">
            <div className='cardDetailInr'>
              <img src={lastSubSvg} alt="" title="" />
              <p>Submissions:</p>
            </div>    
              <div className='setViewGrade'>
                <span>{activeSubmission?.submissions || "0"}</span>
                {/* {activeSubmission?.submissions > 0 && view_result ? (
                    <span onClick={getUserSubmissions} className='viewGridCstm'> 
                      {loader && <Loading size={17} />}View Grade
                    </span>
                ) : null} */}
              </div>
            
          </div> 
          
          {get(assignment, "scheduleAt") ? (
            <div className="cardDetail">
             <div className='cardDetailInr'>
               <img src={clockSvg} alt="" title="" />
               <p>Start Date:</p>
              </div>  
              <span>{moment(get(assignment, "scheduleAt")).format(
                  "MMM DD, YYYY hh:mm A"
                )}
              </span>
          </div> 
          ) : null}

          <div className="cardDetail">
             <div className='cardDetailInr'>
               <img src={dueDateSvg} alt="" title="" />
               <p>Due Date:</p>
              </div>  
              <span>
                {moment(get(assignment, "dueDate")).format(
                  "MMM DD, YYYY hh:mm A"
                )}
              </span>
          </div> 

          {showCountdownTimer && currentUser?.role === 'student' && (get(assignment, "dueDate") || (get(assignment, "lateDate") && !shouldSkipLateDateForDiffStudent(assignment, currentUser, currentClass))) && (
            <div className="cardDetail">
              <div className='cardDetailInr'>
                <img src={clockSvg} alt="" title="" />
                <p>Time left to submit:</p>
              </div>
                <CountdownTimer 
                 dueDate={get(assignment, "dueDate")} 
                 lateDate={shouldSkipLateDateForDiffStudent(assignment, currentUser, currentClass) ? null : get(assignment, "lateDate")}
                 onTimeUp={() => {
                  //  if (assignment?.data?.id) {
                  //    localStorage.removeItem(`finishLater_${assignment.data.id}`);
                  //  }
                 }}
               />
            </div>
          )}

          {activeSubmission && view_result  && (
            <div className="cardDetail">
                <div className='cardDetailInr'>
                <img src={lastSubSvg} alt="" title="" />
                <p>Grade:</p>
                </div>  
                <span>
                <GradeBadge grade={getGrade()} />
                </span>
                

            </div> 
          )}
        {is_engage_activity && (
           <span style={{ color: "#03989e",textAlign: "left" }}>
           (Engage Activity)
         </span>
        )}

          {!view_result&&activeSubmission?<NoteMark note={"Grade and feedback will be show upon the teacher approval"} />:null}
          
        </Column>
        </Row>
        </div>
        <div className='assignNotifyRght assignNotifyRghtStudentSide'><img src={modalSrc}  width="" height={""} alt="" /></div>
       </div>  
      </div>

      <div className='assignBtnsCollectTchr'>
      {userRol === "student" ? (
          <TootipWrapper
            className="studentTakeNow"
            hasToolTip={!effectiveActive}
            label={!effectiveActive ? "Assignment is deactivated by teacher" : null}>
              <div className='assignBtnStatus'>
                <p style={{ padding: 0, margin: 0 }} onClick={checkRetake}> {getStatusText()} </p>
              </div>
              <div className={`setRotateText status-assignement-${assignment?.data?.is_exam || isGeneratedTest ? "white": "black"}`}>{setRotateStatusText()}</div>
          </TootipWrapper>
        ) : (
          <TextLarge complete={activeSubmission?.complete}>Preview</TextLarge>
        )}
       

        <div className='viewGradeBtnTchr'>
          {activeSubmission?.submissions > 0 && view_result && !loader ? (
            <span onClick={getUserSubmissions}>
              View grade
            </span>
          ) : loader ? (
            <span className='viewGradeBtnTchrLoader'><Loading size={16} /></span>
          ) : null}
        </div>


      </div>  

    </Wrapper>
    </SentryWrap>);
};

export default AssignmentNotification;
